// eslint-disable-next-line no-shadow
export enum IntegrationType {
  Discord,
  Rust,
}
